export const state = {
  list: [],
  pagination: {},
  count: 0
}
